import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {Category} from "../../models/category";
import {Constants} from "../../constants";

@Injectable({
    providedIn: 'root'
})
export class CategoryService {

    constructor(private http: HttpClient) {
    }

    getRequestHeaders() {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem(Constants.LOCAL_TOKEN) ?? environment.publicApiToken
        });
    }

    getPublicRequestHeaders() {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': environment.publicApiToken,
        });
    }

    async getCategories(companyId: string, publicApi?: boolean, extParams?: any) {
        let categories: Category[] = [];

        let params = {companyId, ...extParams}

        try {
            let response: any = await this.http.get(publicApi ? environment.publicApiUrl + '/categories' : environment.apiUrl + '/categories', {
                headers: publicApi ? this.getPublicRequestHeaders() : this.getRequestHeaders(),
                params
            }).toPromise();
            if (response.success) {
                categories = response.data
                   /* .map((category: Category) => {
                        return {
                            id: category.id,
                            name: category.name,
                            parentId: category.parentId,
                            fullPrice: category.fullPrice
                        }
                    }
                )*/
            }
        } catch (e) {
            console.error('Error in Category service getAll: ', e)
        } finally {
            return categories;
        }


    }

    async getCategoryById(id: string) {
        let category: Category = new Category();

        try {
            let response: any = await this.http.get(environment.apiUrl + `/categories/${id}`, {
                headers: this.getRequestHeaders(),
            }).toPromise()

            if (response.success) {
                category = response.data;
            }

        } catch (e) {
            console.error('error getAllAthletes: ', e)
        } finally {
            return category;
        }
    }

    async createCategory(newCategory: Category) {

        try {
            let response: any = await this.http.post(environment.apiUrl + '/categories', newCategory, {
                headers: this.getRequestHeaders()
            }).toPromise();

            return response.success
        } catch (e) {
            console.error('error createCategory: ', e);
        }
    }

    async updateCategory(updatedCategory: Category) {
        let response: any;
        try {
            response = await this.http.put(environment.apiUrl + `/categories/${updatedCategory.id}`, updatedCategory, {headers: this.getRequestHeaders()}).toPromise();
        } catch (e) {
            console.error('error UpdateCategory: ', e)
        } finally {
            return response.success;
        }
    }

    async deleteCategory(categoryId: string) {
        let response: any;
        try {
            response = await this.http.delete(environment.apiUrl + `/categories/${categoryId}`, { headers: this.getRequestHeaders() }).toPromise();
        } catch (e) {
            console.error('error UpdateCategory: ', e)
        } finally {
            return response.success;
        }
    }

}
